import React, {Component} from "react";
import './PageHolder.css';
import {Col, Modal, Row} from "react-bootstrap";
import glossary from '../scripts/model/glossary.json'

class PageHolder extends Component {
  constructor(props) {
      super(props);
      this.state = {
          showGlossaryModal: false
      }
  }

  showModal = () => this.setState({showGlossaryModal: 'show'});
  hideModal = () => this.setState({showGlossaryModal: false});

  renderGlossaryModal = () => {
      return (
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showGlossaryModal}
            onHide={this.hideModal}
            className={''}
          >
           <Modal.Header closeButton onClick={this.hide}>
               <Modal.Title id="contained-modal-title-vcenter">
                   Explanation of Terms
               </Modal.Title>
           </Modal.Header>
           <Modal.Body>
               {glossary.map(info => {
                   return(
                       <p><b>"{info.term}"</b> {info.definition}</p>
                   )
               })}
           </Modal.Body>
              <Modal.Footer>
                  <button onClick={this.hideModal}>Close</button>
              </Modal.Footer>
          </Modal>
      )
  }

  render() {
    return (
      <div className={'pageHolder'}>
        <div className={'headerStyles'}>
          <div className={'header2Styles'}>
            <Row>
                <Col xs={12} sm={6} className={"p-0"}>
                    <div className={'header3Styles'} >{this.props.pageHeader}</div>
                </Col>
                {/* 2022.04.07.ADivelbiss - Moved below to be more prominent on the page.*/}
                {/*{*/}
                {/*    this.props.showGlossaryModalLink && (*/}
                {/*        <Col xs={12} sm={6} className={'p-0'}>*/}
                {/*            <div className={'text-center text-sm-right'}>*/}
                {/*                <p onClick={this.showModal}><u>Explanation of Terms</u></p>*/}
                {/*            </div>*/}
                {/*        </Col>*/}
                {/*    )*/}
                {/*}*/}
            </Row>
          </div>
        </div>
        {
            this.props.showGlossaryModalLink && (
                <Row className={'pb-0'}>
                  <Col xs={12} className={'p-0'}>
                    <div className={'text-center'}>
                      <a className={'glossary-link'} onClick={this.showModal}>Explanation of Terms</a>
                    </div>
                  </Col>
                </Row>
            )
        }
        <div className={'childStyles'} >
          {this.props.children}
        </div>
          {
              this.props.showGlossaryModalLink && (

                  // <button onClick={this.showModala}>modal</button>
                  this.renderGlossaryModal()
              )
          }
      </div>
    );
  }

}

export default PageHolder;
